import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WmTransitionModule } from '../transition/index';
import { WmCardModule } from '../card/index';
import { MultiselectAltComponent } from './multiselect-alt.component';
import { WmCheckboxModule } from '../checkbox/index';
import { FormsModule } from '@angular/forms';

@NgModule({
	declarations: [MultiselectAltComponent],
	imports: [CommonModule, WmTransitionModule, WmCardModule, WmCheckboxModule, FormsModule],
	exports: [MultiselectAltComponent]
})
export class WmMultiselectAltModule {}
